import React, { useState } from 'react';
import { shareCard } from './shareCard.js';

export default function ShareButton({ opts, label, testId }) {
  const [fallback, setFallback] = useState(null); const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    try { const r = await shareCard(opts); if (!r.shared && r.url) setFallback(r); } finally { setBusy(false); }
  }
  const t = fallback && encodeURIComponent(fallback.text);
  return (<>
    <button className="btn ghost" data-testid={testId} disabled={busy} onClick={go}>{busy ? 'Preparing…' : label}</button>
    {fallback && <div className="card share-fb" data-testid="share-fallback">
      <img src={fallback.url} alt="Share card" data-testid="share-card-preview" />
      <div className="botnav">
        <a className="btn" href={fallback.url} download="trading-secret-quiz.png" data-testid="share-download">Download</a>
        <a className="btn ghost" target="_blank" rel="noreferrer" href={`https://t.me/share/url?url=${encodeURIComponent(window.location.origin)}&text=${t}`} data-testid="share-telegram">Telegram</a>
        <a className="btn ghost" target="_blank" rel="noreferrer" href={`https://wa.me/?text=${t}`} data-testid="share-whatsapp">WhatsApp</a>
      </div>
      <p className="muted small center">Download gambar dulu, kemudian attach dalam Telegram / WhatsApp.</p>
      <button className="back" data-testid="share-close" onClick={() => setFallback(null)}>✕ Close</button>
    </div>}
  </>);
}
